import type { PricingEngineType } from '@/shared/generated'

import { SettingsTemplateType } from '@/shared/generated'

type SettingConfig = {
	name: string
	getTemplateType: (engine: PricingEngineType) => SettingsTemplateType
	template_types: SettingsTemplateType[]
}
export const getSettingConfig = (setting: string): SettingConfig => {
	switch (setting) {
		case 'min_steps':
			return {
				name: 'minimal_steps',
				getTemplateType: () => SettingsTemplateType.PricingCampaignMinimalSteps,
				template_types: [SettingsTemplateType.PricingCampaignMinimalSteps],
			}
		case 'assignment':
			return {
				name: 'product_assignments',
				getTemplateType: () =>
					SettingsTemplateType.PricingCampaignProductAssignment,
				template_types: [SettingsTemplateType.PricingCampaignProductAssignment],
			}
		case 'tactics':
			return {
				name: 'pricing_tactics',
				getTemplateType: (engine: PricingEngineType) =>
					`pricing_campaign_tactics_${engine.toLowerCase()}` as SettingsTemplateType,
				template_types: [
					SettingsTemplateType.PricingCampaignTacticsRb,
					SettingsTemplateType.PricingCampaignTacticsMl,
					SettingsTemplateType.PricingCampaignTacticsMd,
					SettingsTemplateType.PricingCampaignTacticsPromo,
				],
			}
		case 'repricing_limits':
			return {
				name: 'price_limits',
				getTemplateType: () => SettingsTemplateType.PricingCampaignLimits,
				template_types: [SettingsTemplateType.PricingCampaignLimits],
			}
		default:
			return {
				name: setting,
				getTemplateType: () =>
					`pricing_campaign_${setting}` as SettingsTemplateType,
				template_types: [`pricing_campaign_${setting}` as SettingsTemplateType],
			}
	}
}
